import { Link } from 'react-router-dom';
import styled, { keyframes } from "styled-components";

export const EMContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const EMBody = styled.div`
    width: 100%;
    height: 100%;
    margin-top: 1rem;
    justify-items: center;
`

export const EMTableContainer = styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;
     @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        width: 100%;
    }
`

export const QuestionText = styled.h2`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    text-align: center;
    background-color:#d0d4d7;
    padding:12px;
    margin:0px;
`;

export const OptionButton = styled.button`
  background: ${(props) => (props.selected ? props.theme.colors.primary : "white")};
  color: ${(props) => (props.selected ? "white" : "#333")};
  border: 2px solid ${(props) => (props.selected ? props.theme.colors.primary : "#ccc")};
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 10px;
  width: 100%;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    border-color: ${(props) =>  props.theme.colors.primary };
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`;

export const IndexQuestion = styled.div`
    color:#ffffff;
    font-style: italic;
    font-size: 1rem;
    align-self: start;
    background-color: #fab134;
    box-shadow: 2px 1px 5px 1px #7b7b7b;
    border-radius: 6px;
    margin-right: 2%;
    position: relative;
    padding: 6px;
    &:before {
        content: "";
        position: absolute;
        top: 92%; /* Ajustez selon vos besoins */
        right: 25%; /* Ajustez selon vos besoins */
        border-width: 10px;
        border-style: solid;
        border-color:  #fab134 transparent transparent transparent;
    }

`;

export const NavButton = styled.button` 
    background: ${({ theme, primary }) => primary ? theme.colors.success : theme.colors.danger};
    color: ${({ theme, primary }) => primary ? "white" : "white"};
    border: none;
    border-radius: 10px;
    padding: 8px 12px;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.2s ease;
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    &:hover {
        background: ${({ theme, primary }) => primary ? theme.colors.success : "#ccc"};
        border :1px solid ${({ theme, primary }) => primary ? theme.colors.success : "#ccc"};
    }
`;

export const dropDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-200px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

export const ModalBox = styled.div`
  background: white;
  padding: 2rem 3rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: ${dropDown} 0.5s ease forwards;
  max-width: 450px;
    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      max-width: 350px;
    
    }
`;

export const Message = styled.p`
  color: #333;
  font-size: 1.1rem;
  margin: 1rem 0 2rem;
`;

export const Button = styled.button`
  padding: 0.6rem 1.4rem;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease;
  
  ${(props) =>
        props.variant === "confirm"
            ? `
    background: ${props.theme.colors.success};
    color: white;
    &:hover { background: ${props.theme.colors.success};border:1px solid ${props.theme.colors.success} }
  `
            : `
    background: #f0f0f0;
    color: #333;
    &:hover { background: #e0e0e0;border:1px solid #f0f0f0 }
  `}
`;

export const HeaderLocation = styled.h3`
    font-size: 1.5rem;
    margin-bottom: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    color:${({ theme }) => theme.colors.primary};
    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
        font-size: 1.175rem;
    }
`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 0.5rem; 
    border-bottom: 3px solid #f5fbff;
    @media (max-width: ${({ theme }) => theme.size.tabletL}) {
        flex-direction: column;
    }  
`;

export const TitleHeader = styled.h3` 
    font-size: 0.9rem;
    color: #666;
    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      font-size: 0.8rem;
    }   
`